import React from 'react';
import { useSelector } from 'react-redux'
import { Button, Row, Col, FormText} from 'react-bootstrap';
import InputRadio from '../UI/Control/InputRadio';
import TextArea from '../UI/Control/InputTextarea';
import InputString from '../UI/Control/InputString';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import AddManualTaskModal from './AddManualTaskModal';

const QCComplete = (props) => {
    const taskId = props.taskId;
    const EDCUserID = useSelector(state => state.auth.gValue01);

    const SaveQCComplete = (event) => {
        let objNote = document.getElementById('QCCompletNote');       
        let objTestVidApproved = document.querySelector("input[name=TestVidApproved]:checked");
        let objVideoMatchRange = document.querySelector("input[name=VideoMatchRange]:checked");
        let objCorrectProtocol = document.querySelector("input[name=CorrectProtocol]:checked");
        let objParticipantID = document.querySelector("input[name=ParticipantID]:checked");
        let objVisitID = document.querySelector("input[name=VisitID]:checked");
        let objSiteID = document.querySelector("input[name=SiteID]:checked");
        let objInvestigatorMatchesRecords = document.querySelector("input[name=InvestigatorMatchesRecords]:checked");
        let objProcedureVerified = document.querySelector("input[name=ProcedureVerified]:checked");
        let objIdentifiersVisible = document.querySelector("input[name=IdentifiersVisible]:checked");
        let objMaskingApplied = document.querySelector("input[name=MaskingApplied]:checked");
        let objMaskingAppliedComment = document.getElementById("txtMaskingApplied");
        let objLandmarks = document.querySelector("input[name=Landmarks]:checked");
              
      
        if (objTestVidApproved == null) {
            alert('Please select response for "test video approved".');
            objTestVidApproved.focus();
            return false;
        }
        if (objVideoMatchRange == null) {
            alert('Please select response for "Total Video Time Matches Expected Range".');
            objVideoMatchRange.focus();
            return false;
        }
        if (objCorrectProtocol == null) {
            alert('Please select response for "Protocol ID".');
            objCorrectProtocol.focus();
            return false;
        }
        if (objParticipantID == null) {
            alert('Please select response for "Participant ID".');
            objParticipantID.focus();
            return false;
        }
        if (objVisitID == null) {
            alert('Please select response for "Visit ID".');
            objVisitID.focus();
            return false;
        }
        if (objSiteID == null) {
            alert('Please select response for "Site ID".');
            objSiteID.focus();
            return false;
        }
        if (objInvestigatorMatchesRecords == null) {
            alert('Please select response for "Principal Investigator Matches Records".');
            objInvestigatorMatchesRecords.focus();
            return false;
        }
        if (objProcedureVerified == null) {
            alert('Please select response for "Date of Procedure Verified".');
            objProcedureVerified.focus();
            return false;
        }
        if (objIdentifiersVisible == null) {
            alert('Please select response for "Potential Identifiers/Faces Visible".');
            objIdentifiersVisible.focus();
            return false;
        }
        if (objMaskingApplied == null) {
            alert('Please select response for "Masking Applied".');
            objMaskingApplied.focus();
            return false;
        }
        if (objLandmarks == null) {
            alert('Please select response for "All Landmark times present (if applicable)".');
            objLandmarks.focus();
            return false;
        }       

        let qcModel = {
            TaskID: taskId,
            QCCompletNote: objNote.value,           
            TestVidApproved: objTestVidApproved == null ? null : objTestVidApproved.value,
            VideoMatchRange: objVideoMatchRange == null ? null : objVideoMatchRange.value,
            CorrectProtocol: objCorrectProtocol == null ? null : objCorrectProtocol.value,
            ParticipantID: objParticipantID == null ? null : objParticipantID.value,
            VisitID: objVisitID == null ? null : objVisitID.value,
            SiteID: objSiteID == null ? null : objSiteID.value,
            InvestigatorMatchesRecords: objInvestigatorMatchesRecords == null ? null : objInvestigatorMatchesRecords.value,
            ProcedureVerified: objProcedureVerified == null ? null : objProcedureVerified.value,
            IdentifiersVisible: objIdentifiersVisible == null ? null : objIdentifiersVisible.value,
            MaskingApplied: objMaskingApplied == null ? null : objMaskingApplied.value,
            Landmarks: objLandmarks == null ? null : objLandmarks.value,           
            CreationUser: EDCUserID,
            MaskingAppliedComment: objMaskingAppliedComment == null ? null : objMaskingAppliedComment.value 
        };

        fetch('api/ImageService/SaveQCComplete', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(qcModel)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('QC not completed, Something went wrong.');
            }
            if (res > 0) {
                if (props.taskType == "cims-zelta") {
                    props.relaodAction();
                }
                else {
                    //Moved subject creation to Read Assign stage on 09 Dec 2025.
                    //createSubject();
                    props.relaodAction();
                }
            }
        })
    };
    const createSubject = async () => {
        const response = await fetch('api/ServiceCall/CreateSubject?TaskId=' + taskId + '&CreationUser=' + EDCUserID,
            {
                method: "POST",
                mode: 'cors'
            }
        )
        let retData = await response.text();
        if (retData.trim() != "\"SubjectCreated\"") {
            alert("Error while creating subject: " + retData);
        }
    }
    const showMaskComment = (ctr) => {
        let objMaskingApplied = document.querySelector("input[name=MaskingApplied]:checked");
        if (objMaskingApplied.value == "Y")
            document.getElementById("txtMaskingApplied").style.display = "block";
        else
            document.getElementById("txtMaskingApplied").style.display = "none";;
    }
    return (
        <div>
            <Row className="mt-2 mb-2">
                <Col md={6}>
                    <Row>
                        <Col md={2}>
                            Notes:
                    </Col>
                        <Col md={10}>
                            <TextArea rows='12' cols='60' id="QCCompletNote" />
                        </Col>
                    </Row>
                </Col>
                <Col Col={6}>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Test Video Approved <MandatoryLabel />:
                         </Col>
                        <Col md={6}>
                            <InputRadio id="TestVidApprovedYes" orientation='horizontal' value="Y" name="TestVidApproved" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="TestVidApprovedNo" orientation='horizontal' value="N" name="TestVidApproved" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <a style={{ "margin-left": "45px", display: "none" }} href='#'>Link to Test Video</a>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Total Video Time Matches Expected Range <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="VideoMatchRangeYes" orientation='horizontal' value="Y" name="VideoMatchRange" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="VideoMatchRangeNo" orientation='horizontal' value="N" name="VideoMatchRange" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Protocol ID <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="CorrectProtocolYes" orientation='horizontal' value="Y" name="CorrectProtocol" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="CorrectProtocolNo" orientation='horizontal' value="N" name="CorrectProtocol" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Participant ID <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="PartIDYes" orientation='horizontal' value="Y" name="ParticipantID" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="PartIDNo" orientation='horizontal' value="N" name="ParticipantID" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Visit ID <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="VisitIDYes" orientation='horizontal' value="Y" name="VisitID" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="VisitIDNo" orientation='horizontal' value="N" name="VisitID" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Site ID <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="SiteIDYes" orientation='horizontal' value="Y" name="SiteID" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="SiteIDNo" orientation='horizontal' value="N" name="SiteID" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Principal Investigator Matches Records <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="InvMatchRecYes" orientation='horizontal' value="Y" name="InvestigatorMatchesRecords" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="InvMatchRecNo" orientation='horizontal' value="N" name="InvestigatorMatchesRecords" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Date of Procedure Verified <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="ProcVerifiedYes" orientation='horizontal' value="Y" name="ProcedureVerified" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="ProcVerifiedNo" orientation='horizontal' value="N" name="ProcedureVerified" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Potential Identifiers/Faces Visible <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="IdentifiersVisibleYes" orientation='horizontal' value="Y" name="IdentifiersVisible" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="IdentifiersVisibleNo" orientation='horizontal' value="N" name="IdentifiersVisible" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            Masking Applied <MandatoryLabel />:
                        </Col>
                        <Col md={6}>
                            <InputRadio id="MaskingAppliedYes" orientation='horizontal' value="Y" name="MaskingApplied" text="Yes" onChange={showMaskComment} style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="MaskingAppliedNo" orientation='horizontal' value="N" name="MaskingApplied" text="No" onChange={showMaskComment}style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputString id="txtMaskingApplied" maxlength="495" style={{ "display":"none"}}/>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            All Landmark times present (if applicable) <MandatoryLabel />:
                        </Col>
                        <Col md={4}>
                            <InputRadio id="LandmarksYes" orientation='horizontal' value="Y" name="Landmarks" text="Yes" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="LandmarksNo" orientation='horizontal' value="N" name="Landmarks" text="No" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                            <InputRadio id="LandmarksNA" orientation='horizontal' value="NA" name="Landmarks" text="NA" style={{ "margin-left": "10px", "margin-right": "5px" }}></InputRadio>
                        </Col>
                        <Col md={2}>
                            <Button className="btn-success" onClick={SaveQCComplete} disabled={props.isTaskDetailsMissing} > Submit </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="mt-2 mb-2">
                <Col md={12} style={{ "text-align": "center" }}></Col>
            </Row>
        </div>
    );
}
export default QCComplete;
